import {
  ADD_TRANSITION,
  REMOVE_TRANSITION,
  TOGGLE_MODELTESTSTATE,
  SHOW_ALERT,
  CART_ITEMS,
  HIDE_ALERT,
  SHOW_CART_REFRESH_BANNER,
  HIDE_CART_REFRESH_BANNER,
  SESSION_ID,
  UPDATE_CART,
  CLEAR_CART,
  SET_SELECTED_STORE,
  SET_DYNAMIC_BREADCRUMBS,
  SHOW_REGION_MODAL,
  CHECKOUT_PROGRESS,
  SET_PROGRESS_STEPS,
  HIDE_TRIGGER
} from "../actions/actions";
import { CLOSE_MENU, TOGGLE_MENU, LOGOUT, SETHEADERHEIGHT, SET_STAFF_INFO, SET_USER_INFO, PDP_ACTION_SEGMENT } from "../actions";
import { TOGGLE_IFRAME, CHANGE_MODEL } from "../actions/model";
import { TOGGLE_COOKIES, CHANGE_COOKIES, CHANGE_ANIMATION } from "../actions/cookies";
import { FAQ } from "../actions/faq";
import { TOGGLE_MARKETDETECTOR, CHANGE_MARKETDETECTOR } from "../actions/marketDetector";
import { BECOMEAMEMBER_SUMMARY, CALCULATION_PRICE, CLEARCALCULATION_PRICE, CLEARCOMPARISONTOOL_APIBODY, COMPARISONTOOL_APIBODY, SHOW_CHANGE_MEMBERSHIP_MODELS } from "../actions/becomeAMember";
import { webStorage, S_USER, S_BECOME_A_MEMBER_SUMMARY, S_CART_ITEMS, S_SESSION_ID, S_STORE, S_STAFF_INFO, clearWebStorageAfterLogout } from "../../utils/webStorage";
import { canUseDOM } from "../../utils";
import { restoreData } from "../restoreData";
import { gearCheckoutReducer, gearCheckoutStates } from "./gears-checkout-reducers";
import { GEAR_ACTION_SEGMENT } from "../actions/gears-checkout";
import { CAR_BOOKING_ACTION_SEGMENT } from "../actions/car-booking";
import { carBookingReducer, initialCarBookingStates } from "./car-booking";
import { initialLogic } from "../../services/productService";
import { initialPdpState, pdpReducers } from "./pdp";
import cookie from "react-cookies";
const user = restoreData(S_USER, null);
const becomeAMemberSummary = restoreData(S_BECOME_A_MEMBER_SUMMARY, null);
const cartItems = canUseDOM() ? webStorage.getCartItems(S_CART_ITEMS) : [];
const sessionId = restoreData(S_SESSION_ID, null);
const club = restoreData(S_STORE, null);
const staffInfo = restoreData(S_STAFF_INFO, null);
const initialState = {
  isMenuOpen: false,
  transition: {},
  modelTestState: false,
  toggleIframe: {
    isIframe: {},
    isNestedGrid: false
  },
  showMarketBanner: true,
  showCookieBanner: false,
  animationIsOver: false,
  showModel: false,
  headerHeight: 0,
  user,
  club,
  becomeAMemberSummary,
  calculationPrice: {},
  comparisonToolApiBody: {},
  isCartAlertVisible: false,
  cartInfo: null,
  disabledSkuIds: [],
  cartItems,
  showChangeMembershipModels: {
    level1: false,
    level2: false,
    level3: false,
    levelSame: false,
    fromLevel3: false,
    url: ""
  },
  alertItems: [],
  sessionId,
  isCartRefreshBannerVisible: false,
  faq: {},
  staffInfo,
  ...gearCheckoutStates,
  ...initialPdpState,
  ...initialCarBookingStates,
  progressBarIndex: null
};
function rootReducer(state = initialState, action) {
  const { type, ...data } = action;
  const [ACTION_SEGMENT] = type.indexOf("_") > 0 ? type.split("_") : [null];
  switch (ACTION_SEGMENT) {
    case GEAR_ACTION_SEGMENT:
      return gearCheckoutReducer(state, action);
    case PDP_ACTION_SEGMENT:
      return pdpReducers(state, action);
    case CAR_BOOKING_ACTION_SEGMENT:
      return carBookingReducer(state, action);
    default:
      switch (type) {
        case ADD_TRANSITION:
          return {
            transition: {
              ...state.transition,
              name: action.name,
              path: action.path,
              title: action.title,
              fromRight: action.fromRight,
              play: true,
              linktype: action.linktype,
              curtainBackgroundColor: action.curtainBackgroundColor
            }
          };
        case REMOVE_TRANSITION:
          return {
            transition: {}
          };
        case CLOSE_MENU:
          return {
            ...state,
            isMenuOpen: false
          };
        case TOGGLE_MENU:
          return {
            ...state,
            isMenuOpen: !state.isMenuOpen
          };
        case SET_USER_INFO:
          webStorage.set(S_USER, data);
          return {
            ...state,
            userAccount: data.userAccount,
            user: {
              ...data
            }
          };
        case LOGOUT:
          clearWebStorageAfterLogout();
          return {
            ...state,
            userAccount: null,
            user: null
          };
        case SET_SELECTED_STORE:
          webStorage.set(S_STORE, action.val);
          return {
            ...state,
            club: action.val
          };
        case SETHEADERHEIGHT:
          // console.log("action header height", action.value, action);
          return {
            ...state,
            headerHeight: action.val
          };
        case TOGGLE_MODELTESTSTATE:
          return {
            modelTestState: action.modelTestState
          };
        case TOGGLE_IFRAME:
          return {
            toggleIframe: {
              ...state.toggleIframe,
              path: action.path,
              nestedGrid: action.nestedGrid
            }
          };
        case CHANGE_MODEL:
          return {
            ...state,
            showModel: action.val
          };
        case CHANGE_COOKIES:
          return {
            ...state,
            showCookieBanner: action.val
          };
        case TOGGLE_COOKIES:
          return {
            showCookieBanner: !state.showCookieBanner
          };
        case CHANGE_ANIMATION:
          return {
            ...state,
            animationIsOver: action.val
          };
        case CHANGE_MARKETDETECTOR:
          return {
            ...state,
            showMarketBanner: action.val
          };
        case TOGGLE_MARKETDETECTOR:
          return {
            showMarketBanner: !state.showMarketBanner
          };
        case BECOMEAMEMBER_SUMMARY:
          webStorage.set(S_BECOME_A_MEMBER_SUMMARY, data);
          return {
            ...state,
            becomeAMemberSummary: data
          };
        case FAQ:
          return {
            ...state,
            faq: {
              type: action.type,
              contentIds: action.contentIds,
              category: action.category
            }
          };
        case CALCULATION_PRICE:
          return {
            ...state,
            calculationPrice: {
              ...action
            }
          };
        case CLEARCALCULATION_PRICE:
          return {
            ...state,
            calculationPrice: {}
          };
        case COMPARISONTOOL_APIBODY:
          return {
            ...state,
            comparisonToolApiBody: action.body
          };
        case CLEARCOMPARISONTOOL_APIBODY:
          return {
            ...state,
            comparisonToolApiBody: {}
          };
        case SHOW_CHANGE_MEMBERSHIP_MODELS:
          return {
            ...state,
            showChangeMembershipModels: {
              level1: action.level1,
              level2: action.level2,
              level3: action.level3,
              levelSame: action.levelSame,
              fromLevel3: action.fromLevel3,
              url: action.url
            }
          };
        case SHOW_ALERT:
          return {
            ...state,
            isCartAlertVisible: true,
            alertItems: [action.details]
          };
        case HIDE_ALERT:
          return {
            ...state,
            isCartAlertVisible: false,
            alertItems: []
          };
        case CART_ITEMS:
          if (action.action === "remove") {
            webStorage.removeCartItem(S_CART_ITEMS, action.ids);
          } else if (action.action === "clear") {
            webStorage.clear(S_CART_ITEMS);
          } else {
            webStorage.addCartItem(S_CART_ITEMS, action.ids);
          }
          return {
            ...state,
            cartItems: webStorage.getCartItems(S_CART_ITEMS)
          };
        case UPDATE_CART: {
          return {
            ...state,
            cartInfo: data
          };
        }
        case CLEAR_CART: {
          const cartInfo = {
            ...state.cartInfo,
            afterDiscountTotalPrice: null,
            currencySymbol: null,
            discountPrice: null,
            skuList: null,
            skuOriginalTotalPrice: null
          };
          return {
            ...state,
            cartInfo
          };
        }
        case SESSION_ID:
          webStorage.set(S_SESSION_ID, action.sessionId);
          return {
            ...state,
            sessionId: action.sessionId
          };
        case SHOW_CART_REFRESH_BANNER:
          return {
            ...state,
            isCartRefreshBannerVisible: true
          };
        case HIDE_CART_REFRESH_BANNER:
          return {
            ...state,
            isCartRefreshBannerVisible: false
          };
        case SET_STAFF_INFO:
          webStorage.set(S_STAFF_INFO, data.val);
          return {
            ...state,
            staffInfo: data.val
          };
        case SET_DYNAMIC_BREADCRUMBS: {
          return {
            ...state,
            dynmicBreadcrumbs: data.val
          };
        }
        case SHOW_REGION_MODAL: {
          return {
            ...state,
            showRegionModal: data.value
          };
        }
        case CHECKOUT_PROGRESS: {
          return {
            ...state,
            progressBarIndex: data.progress_index
          };
        }
        case SET_PROGRESS_STEPS: {
          return {
            ...state,
            progressBarSteps: data.progress_steps
          };
        }
        case HIDE_TRIGGER: {
          return {
            ...state,
            isTriggerHidden: data.value
          };
        }
        default:
          return state;
      }
  }
}

export default rootReducer;
